/* istanbul ignore file */
import React from 'react';
import { Breadcrumbs, ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { usePurchaseOrderUrl } from 'domain/finance/purchaseOrder/shared/usePurchaseOrderRouting';

const PurchaseOrderBreadcrumbs = ({ children }: { children: React.ReactNode }) => {
  const { getListUrl } = usePurchaseOrderUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Purchase Orders" link={getListUrl()} />
      {children}
    </Breadcrumbs>
  );
};

export default PurchaseOrderBreadcrumbs;
